export const ONLINE_STORE_START_SYNCING_PRODUCT_VALIDATION_FLOW =
  'ONLINE_STORE_START_SYNCING_PRODUCT_VALIDATION_FLOW';

export const ONLINE_STORE_START_SYNCING_PRODUCT_FLOW =
  'ONLINE_STORE_START_SYNCING_PRODUCT_FLOW';

export const ONLINE_STORE_START_EXPORT_PRODUCT_FLOW =
  'ONLINE_STORE_START_EXPORT_PRODUCT_FLOW';

export const ONLINE_STORE_START_POST_EXPORT_PRODUCT_FLOW =
  'ONLINE_STORE_START_POST_EXPORT_PRODUCT_FLOW';

export const ONLINE_STORE_SET_PRODUCT_EXPORT_ID =
  'ONLINE_STORE_SET_PRODUCT_EXPORT_ID';

export const ONLINE_STORE_SET_SHOP_DETAIL = 'ONLINE_STORE_SET_SHOP_DETAIL';

export const ONLINE_STORE_SET_SHOP_DETAIL_PRODUCTS =
  'ONLINE_STORE_SET_SHOP_DETAIL_PRODUCTS';

export const ONLINE_STORE_SHOP_DETAIL_PRODUCTS_REQUEST =
  'ONLINE_STORE_SHOP_DETAIL_PRODUCTS_REQUEST';

export const ONLINE_STORE_SHOW_SYNCING_PRODUCT_EMPTY_PRODUCT_MODAL =
  'ONLINE_STORE_SHOW_SYNCING_PRODUCT_EMPTY_PRODUCT_MODAL';
export const ONLINE_STORE_CLOSE_SYNCING_PRODUCT_EMPTY_PRODUCT_MODAL =
  'ONLINE_STORE_CLOSE_SYNCING_PRODUCT_EMPTY_PRODUCT_MODAL';

export const ONLINE_STORE_SHOW_SYNCING_PRODUCT_EMPTY_SYNCED_MODAL =
  'ONLINE_STORE_SHOW_SYNCING_PRODUCT_EMPTY_SYNCED_MODAL';
export const ONLINE_STORE_CLOSE_SYNCING_PRODUCT_EMPTY_SYNCED_MODAL =
  'ONLINE_STORE_CLOSE_SYNCING_PRODUCT_EMPTY_SYNCED_MODAL';

export const ONLINE_STORE_SHOW_GO_STORE_UNACTIVATED_MODAL =
  'ONLINE_STORE_SHOW_GO_STORE_UNACTIVATED_MODAL';
export const ONLINE_STORE_CLOSE_GO_STORE_UNACTIVATED_MODAL =
  'ONLINE_STORE_CLOSE_GO_STORE_UNACTIVATED_MODAL';

export const ONLINE_STORE_SHOW_GO_STORE_NOT_NATION_WIDE_SHIPPING_MODAL =
  'ONLINE_STORE_SHOW_GO_STORE_NOT_NATION_WIDE_SHIPPING_MODAL';
export const ONLINE_STORE_CLOSE_GO_STORE_NOT_NATION_WIDE_SHIPPING_MODAL =
  'ONLINE_STORE_CLOSE_GO_STORE_NOT_NATION_WIDE_SHIPPING_MODAL';

export const ONLINE_STORE_SHOW_SYNCING_PRODUCT_IN_SYNC_MODAL =
  'ONLINE_STORE_SHOW_SYNCING_PRODUCT_IN_SYNC_MODAL';
export const ONLINE_STORE_CLOSE_SYNCING_PRODUCT_IN_SYNC_MODAL =
  'ONLINE_STORE_CLOSE_SYNCING_PRODUCT_IN_SYNC_MODAL';

export const ONLINE_STORE_SHOW_SYNCING_PRODUCT_RESULT_MODAL =
  'ONLINE_STORE_SHOW_SYNCING_PRODUCT_RESULT_MODAL';
export const ONLINE_STORE_CLOSE_SYNCING_PRODUCT_RESULT_MODAL =
  'ONLINE_STORE_CLOSE_SYNCING_PRODUCT_RESULT_MODAL';

export const ONLINE_STORE_SHOW_SYNCING_PRODUCT_DONE_MODAL =
  'ONLINE_STORE_SHOW_SYNCING_PRODUCT_DONE_MODAL';
export const ONLINE_STORE_CLOSE_SYNCING_PRODUCT_DONE_MODAL =
  'ONLINE_STORE_CLOSE_SYNCING_PRODUCT_DONE_MODAL';

export const ONLINE_STORE_START_POST_SYNCING_PRODUCT_FLOW =
  'ONLINE_STORE_START_POST_SYNCING_PRODUCT_FLOW';

export const ONLINE_STORE_SHOW_OUTLET_MODAL = 'ONLINE_STORE_SHOW_OUTLET_MODAL';

export const ONLINE_STORE_CLOSE_OUTLET_MODAL =
  'ONLINE_STORE_CLOSE_OUTLET_MODAL';

export const ONLINE_STORE_LOADING_PAGE_REQUEST =
  'ONLINE_STORE_LOADING_PAGE_REQUEST';

export const ONLINE_STORE_FINISH_PAGE_REQUEST =
  'ONLINE_STORE_FINISH_PAGE_REQUEST';

export const ONLINE_STORE_PAGE_REQUEST = 'ONLINE_STORE_PAGE_REQUEST';

export const ONLINE_STORE_START_SELECT_OUTLET_FLOW =
  'ONLINE_STORE_START_SELECT_OUTLET_FLOW';

export const ONLINE_STORE_SET_SHOPS = 'ONLINE_STORE_SET_SHOPS';

export const ONLINE_STORE_START_FACEBOOK_SIGN_IN_FLOW =
  'ONLINE_STORE_START_FACEBOOK_SIGN_IN_FLOW';

export const ONLINE_STORE_SHOW_DISCONNECT_SHOP_MODAL =
  'ONLINE_STORE_SHOW_DISCONNECT_SHOP_MODAL';
export const ONLINE_STORE_CLOSE_DISCONNECT_SHOP_MODAL =
  'ONLINE_STORE_CLOSE_DISCONNECT_SHOP_MODAL';
export const ONLINE_STORE_DISCONNECT_SHOP = 'ONLINE_STORE_DISCONNECT_SHOP';

export const ONLINE_STORE_CONNECT_GOOGLE_SHOP =
  'ONLINE_STORE_CONNECT_GOOGLE_SHOP';

export const ONLINE_STORE_OPEN_CONNECT_GOOGLE_EMAIL_MODAL =
  'ONLINE_STORE_OPEN_CONNECT_GOOGLE_EMAIL_MODAL';

export const ONLINE_STORE_CLOSE_CONNECT_GOOGLE_EMAIL_MODAL =
  'ONLINE_STORE_CLOSE_CONNECT_GOOGLE_EMAIL_MODAL';

export const ONLINE_STORE_CONNECT_GOOGLE_EMAIL =
  'ONLINE_STORE_CONNECT_GOOGLE_EMAIL';

export const ONLINE_STORE_FACEBOOK_MODAL_OPENED =
  'ONLINE_STORE_FACEBOOK_MODAL_OPENED';

export const ONLINE_STORE_FACEBOOK_MODAL_CLOSED =
  'ONLINE_STORE_FACEBOOK_MODAL_CLOSED';

export const ONLINE_STORE_SELECT_OUTLET = 'ONLINE_STORE_SELECT_OUTLET';

export const ONLINE_STORE_SELECT_OUTLET_INFO =
  'ONLINE_STORE_SELECT_OUTLET_INFO';

export const ONLINE_STORE_SHOW_FACEBOOK_DOMAIN_VERIFICATION_MODAL =
  'ONLINE_STORE_SHOW_FACEBOOK_DOMAIN_VERIFICATION_MODAL';

export const ONLINE_STORE_CLOSE_FACEBOOK_DOMAIN_VERIFICATION_MODAL =
  'ONLINE_STORE_CLOSE_FACEBOOK_DOMAIN_VERIFICATION_MODAL';

export const ONLINE_STORE_SET_BUSINESS_INFO = 'ONLINE_STORE_SET_BUSINESS_INFO';

export const ONLINE_STORE_PATCH_META_TAG = 'ONLINE_STORE_PATCH_META_TAG';

export const ONLINE_STORE_ON_CHANGE_FACEBOOK_DOMAIN_VERIFICATION =
  'ONLINE_STORE_ON_CHANGE_FACEBOOK_DOMAIN_VERIFICATION';

export const ONLINE_STORE_SHOW_UPDATE_REQUIRED_MODAL =
  'ONLINE_STORE_SHOW_UPDATE_REQUIRED_MODAL';

export const ONLINE_STORE_CLOSE_UPDATE_REQUIRED_MODAL =
  'ONLINE_STORE_CLOSE_UPDATE_REQUIRED_MODAL';
